import React, { forwardRef } from 'react';
import { useController } from 'react-hook-form';
import { FormControl, TextField } from '@mui/material';

/**
 * Applies a mask pattern to a raw value.
 * '9' in the mask means any digit. Other characters are literals.
 */
const applyMask = (rawValue, mask) => {
    const digits = (rawValue || '').replace(/[^0-9]/g, '');
    let result = '';
    let digitIndex = 0;

    for (let i = 0; i < mask.length && digitIndex < digits.length; i++) {
        if (mask[i] === '9') {
            result += digits[digitIndex];
            digitIndex++;
        } else {
            result += mask[i];
        }
    }

    return result;
};

export const MaskInputMain = forwardRef(
    (
        {
            onClickButton,
            name,
            value,
            type = 'text',
            placeholder,
            label,
            labelHeader,
            disabled,
            classNameWrapper,
            error = '',
            control = {},
            rules,
            mask,
            variant,
        },
        ref
    ) => {
        const { field = {}, fieldState = {} } = useController({ name, control, rules });
        const currentMask = mask || '(999) 999-9999';

        const displayValue = applyMask(field.value || '', currentMask);

        const handleChange = (e) => {
            const raw = e.target.value.replace(/[^0-9]/g, '');
            field.onChange(raw);
        };

        return (
            <div className={`input-main-wrapper input-custom-wrapper  ${classNameWrapper ? classNameWrapper : ''}`}>
                <FormControl variant={variant ? variant : 'standard'} error={error || fieldState?.error?.message} disabled={disabled}>
                    {labelHeader && (
                        <p className={`input-main-label-header ${error || fieldState?.error?.message ? 'errorLabel' : ''}`}>
                            {labelHeader}
                            {rules?.required && <span className="input-main-label-header-required">*</span>}
                        </p>
                    )}

                    <TextField
                        error={!!fieldState?.error?.message}
                        name={name}
                        value={displayValue}
                        onChange={handleChange}
                        autoComplete="off"
                        placeholder={placeholder}
                        label={label}
                        disabled={disabled}
                    />
                    <p className="error-message">{error || fieldState?.error?.message}</p>
                </FormControl>
            </div>
        );
    }
);
